module.exports = __webpack_public_path__ + "static/media/axegpromouse-2.17fdfdcb.jpg";